import { gql } from '@apollo/client';
import { SaleItemFragment } from 'graphql/Deal/fragments/dealItemPicker/SaleItemFragment';
/**
 * @const SaleItemQuery
 * @since 1.0.0
 */
export const SaleItemQuery = gql `
  query SaleItemQuery($input: SaleItemInput!) {
    saleItem(input: $input) {
      ...SaleItemFragment
    }
  }

  ${SaleItemFragment}
`;
